import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ 
      background: 'var(--bg-secondary)', 
      borderTop: '1px solid var(--border-light)',
      padding: '80px 0 40px'
    }}>
      <div className="container" style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: window.innerWidth >= 768 ? 'repeat(4, 1fr)' : '1fr',
          gap: '48px',
          marginBottom: '48px'
        }}>
          {/* Logo et Description */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d1dwn4lv_1B38B2D4-E5C6-4A77-86AF-5639CAD654D6.png" 
              alt="Nina Care Institut" 
              style={{ height: '60px', width: 'auto', marginBottom: '16px' }}
            />
            <p className="body-small" style={{ color: 'var(--text-secondary)', marginTop: '16px' }}>
              Soins esthétiques d'exception à Villemoisson-sur-Orge
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '20px' }}>Navigation</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['Accueil', 'Services', 'Tarifs', 'Galerie', 'À Propos', 'Contact'].map((item) => (
                <li key={item} style={{ marginBottom: '12px' }}>
                  <Link 
                    to={item === 'Accueil' ? '/' : `/${item.toLowerCase().replace(/\s/g, '-').replace(/à/g, 'a')}`}
                    className="body-regular"
                    style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s ease' }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--text-primary)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '20px' }}>Contact</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Phone size={18} color="var(--text-secondary)" />
                <a 
                  href="tel:0984630327" 
                  className="body-regular"
                  style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
                >
                  09 84 63 03 27
                </a>
              </li>
              <li style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Mail size={18} color="var(--text-secondary)" />
                <a 
                  href="mailto:contact@ninacareinstitut.fr" 
                  className="body-regular"
                  style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
                >
                  contact@ninacareinstitut.fr
                </a>
              </li>
              <li style={{ marginBottom: '16px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <MapPin size={18} color="var(--text-secondary)" style={{ marginTop: '2px' }} />
                <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  130 Route de Corbeil<br />
                  91360 Villemoisson-sur-Orge
                </span>
              </li>
            </ul>
          </div>

          {/* Horaires */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '20px' }}>Horaires</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li className="body-small" style={{ marginBottom: '8px', color: 'var(--text-secondary)' }}>
                Lundi : Fermé
              </li>
              <li className="body-small" style={{ marginBottom: '8px', color: 'var(--text-secondary)' }}>
                Mardi - Vendredi : 10h - 19h
              </li>
              <li className="body-small" style={{ marginBottom: '8px', color: 'var(--text-secondary)' }}>
                Samedi : 9h - 18h
              </li>
              <li className="body-small" style={{ marginBottom: '8px', color: 'var(--text-secondary)' }}>
                Dimanche : Fermé
              </li>
            </ul>
          </div>
        </div>

        {/* Réseaux sociaux et Copyright */}
        <div style={{ 
          borderTop: '1px solid var(--border-light)',
          paddingTop: '32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <p className="body-small" style={{ color: 'var(--text-light)', margin: 0 }}>
            © 2026 Nina Care Institut. Tous droits réservés.
          </p>
          
          <div style={{ display: 'flex', gap: '16px' }}>
            <a 
              href="https://www.facebook.com/ninacareinstitut" 
              target="_blank"
              rel="noopener noreferrer"
              style={{ 
                color: 'var(--text-secondary)', 
                transition: 'color 0.2s ease' 
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--text-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              aria-label="Facebook"
            >
              <Facebook size={20} />
            </a>
            <a 
              href="https://www.instagram.com/ninacareinstitut" 
              target="_blank"
              rel="noopener noreferrer"
              style={{ 
                color: 'var(--text-secondary)', 
                transition: 'color 0.2s ease' 
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--text-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
